export default "__VITE_ASSET__M1nK8Y4g__"